import SingleDesign from '@/Icons/models/mod_dtf_single_design.svg';
import AxSheet from '@/Icons/models/mod_dtf_ax_sheet.svg';
import MeterSheet from '@/Icons/models/mod_dtf_meter_sheet.svg';

const MODEL_ICONS = {
  mod_dtf_single_design: SingleDesign,
  mod_dtf_ax_sheet: AxSheet,
  mod_dtf_meter_sheet: MeterSheet,
};

const ModelIcon = ({id, label = '', showLabel}) => {
  const Icon = MODEL_ICONS[id];

  const attributes = Icon ? {
    className: 'w-4xl h-4xl m-3xs',
    ...(showLabel
      ? { 'aria-hidden': 'true', focusable: 'false' }
      : { role: 'img', 'aria-label': label }),
  } : null;

  return (
    <span className="flex items-center flex-col absolute inset-y-0 laptop:flex-row laptop:gap-4xs">
      {Icon && <Icon {...attributes} />}
      <If condition={showLabel}>
        <span className="text-center inline-block break-normal">
          {label}
        </span>
      </If>
    </span>
  );
};

export default ModelIcon;
